import {showFormClientSideMessage} from '../../../../Form/actions/messages';
import {priority} from '@priority-software/priority-proto-api/lib';
import {texts} from '../texts';
import {GWTMetaData} from '../api/types';

export const handleBPMMessages = async (data: GWTMetaData) => {
    const {permissions = [], Message = [], fatalerror} = data;
    const permissionRules = permissions[0];

    if (permissionRules) {
        if (permissionRules.isCanChange === '0') {
            showFormClientSideMessage('', priority.netitems.shared.Message.Type.Error, {
                title: texts.warning_label,
                content: texts.permission_rule_upd_error,
                confirmButtonText: texts.ok_btn_text
            });
            return false;
        } else if (permissionRules.isCanChange === '1') {
            return true;
        }
    } else if (fatalerror === '1') {
        showFormClientSideMessage('', priority.netitems.shared.Message.Type.Error, {
            content: Message[0].message
        });
        return false;
    }
    return true;
};
